/**
 * Feature flag for the org-wide Sparky's Reports page (LSP-19340). Runtime env
 * (config/env.json → window.env), so it can be flipped per environment without a
 * code change. Enabled only when VITE_ENABLE_REPORTS is exactly "true"; anything
 * else (unset / "false") hides the nav entry and blocks the /reports route.
 */
export function isReportsEnabled(): boolean {
	return window.env?.VITE_ENABLE_REPORTS === "true";
}
